import { getAxiosInstanceMethods } from 'utils/Axios';
import { axiosInstance } from './axiosInstance';

export type ApiElements<T> = {
  elements: T[];
};

export const api = getAxiosInstanceMethods(axiosInstance);
